module.exports = __webpack_public_path__ + "img/rectangle.6149240b.png";